import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'

import { crudActionsMap } from 'utils/helpers'
import BehaviorForm from 'components/organisms/forms/BehaviorForm'


const BehaviorCrudPage = ({report = false}) => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id
  const action = crudActionsMap[params['*']?.split('/')?.[1]]

  const viewOnly = report || action === 'view' || action === 'delete' 

  return (
    <>
      <PageHeading title={`${t('common.behaviour')} / ${t('common.' + action)}`} />
      <PageBody>
        <BehaviorForm report={report} action={action} id={id} viewOnly={viewOnly} />
      </PageBody>
    </>
  )
}

export default BehaviorCrudPage


